import angular from 'angular';
import { some } from 'lodash';

import DirectiveModule from './directive';
import ComponentModule from './component';
import CalendarComponent from './calendar.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar', [
        DirectiveModule.name,
        ComponentModule.name
    ])
    .component(CalendarComponent.selector, CalendarComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.calendar', {
        url: '/calendar/:teamId?cid',
        component: CalendarComponent.selector,
        params: {
            teamId: {
                value: null,
                squash: true,
                dynamic: true
            },
            cid: {
                array: true,
                value: [],
                squash: true,
                dynamic: true
            }
        },
        resolve: {
            teamId: teamIdResolver,
            calendarIds: calendarIdResolver
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.calendar'
    }, (transition) => {
        let { teamId } = transition.params() || {};

        teamId = +teamId;

        const $state = transition.injector().get('$state');
        const sessionService = transition.injector().get('sessionService');

        if (sessionService.user) {
            sessionService.initialize().then((data) => {
                let { teams } = data;

                if (teamId && !some(teams, (team) => team.id === teamId)) {
                    $state.go('authorized.calendar');
                }
            }).catch(() => {
                $state.go('authorized');
            });

            return true;
        }

        return sessionService.initialize().then((data) => {
            let { teams } = data;

            if (teamId) {
                if (some(teams, (team) => team.id === teamId)) {
                    return true;
                }

                return $state.target('authorized.calendar');
            }

            return true;
        }).catch(() => {
            return $state.target('authorized');
        });
    });
}

/* @ngInject */
function teamIdResolver($transition$) {
    let { teamId } = $transition$.params() || {};

    return teamId || null;
}

/* @ngInject */
function calendarIdResolver($transition$) {
    let { cid } = $transition$.params() || {};

    return cid || [];
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/index.js